export const RemoveIconBig = () => {
  return (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M30 55C16.2144 55 5 43.7856 5 30C5 16.2144 16.2144 5 30 5C43.7856 5 55 16.2144 55 30C55 43.7856 43.7856 55 30 55ZM30 8.125C17.9375 8.125 8.125 17.9375 8.125 30C8.125 42.0625 17.9375 51.875 30 51.875C42.0625 51.875 51.875 42.0625 51.875 30C51.875 17.9375 42.0625 8.125 30 8.125Z"
        fill="#222530"
      />
      <path
        d="M22.2652 39.2904C21.8651 39.2904 21.4649 39.1386 21.1609 38.8323C20.5505 38.2219 20.5505 37.2324 21.1609 36.6221L36.6295 21.1531C37.2402 20.5427 38.2298 20.5427 38.8401 21.1531C39.4505 21.7634 39.4505 22.753 38.8401 23.3637L23.3711 38.8323C23.0629 39.1386 22.6631 39.2904 22.2652 39.2904Z"
        fill="#222530"
      />
      <path
        d="M37.7298 39.2923C37.3301 39.2923 36.9299 39.1405 36.6259 38.8342L21.1573 23.3675C20.5465 22.7572 20.5465 21.7676 21.1573 21.1573C21.7676 20.5465 22.7572 20.5465 23.3675 21.1573L38.8361 36.6259C39.4468 37.2362 39.4468 38.2258 38.8361 38.8361C38.5302 39.1405 38.13 39.2923 37.7298 39.2923Z"
        fill="#222530"
      />
    </svg>
  );
};
